angular.module('callX').controller('SettingsPageCtrl', ['$scope','$stateParams','$modal','UserService','$rootScope', '$state', 'toaster', function($scope,$stateParams,$modal,UserService, $rootScope,$state, toaster) {
    
    var username_agent = $stateParams.username;
    var userId = $stateParams.userId;

    $scope.profiledata = true;
    $scope.managenumbers = false;
    $scope.targetstates = false;
    $scope.appstab = false;
    $scope.appsView = false;
    $scope.enableCancel = false;
    $scope.locObject;
    $scope.profileDataInitialized = false;

    // passowrd hide and show changes 
    // $scope.showEye = false;
    // $scope.hideEye = true;
    // $scope.showpassword = false;
    // $scope.showEye1 = function(){
    //     $scope.showEye = false;
    //     $scope.hideEye = true;
    //     $scope.showpassword = false;
    // };

    // $scope.hideEye1 = function(){
    //     $scope.hideEye = false;
    //     $scope.showEye = true;
    //     $scope.showpassword = true;
    // };
    // passowrd hide and show changes end

    $scope.setAgentFirsAandLastName = function() {
        $scope.username_firstName = window.localStorage.getItem("first_name")
        $scope.username_lastName = window.localStorage.getItem("last_name")
        $scope.user_name = window.localStorage.getItem("user_name")
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.role = window.localStorage.getItem("role")
        if ($scope.role === 'AGENT') {
            $scope.role = 'salesagent';
        }
        $scope.email = window.localStorage.getItem("email")
        if($scope.role == 'useragent'){
            $scope.getuserRole = $scope.role;
            $scope.getAgentStats();
        }else if($scope.role == 'salesagent'){
            $scope.getsalesRole = $scope.role;
            $scope.getsalesAgentStats();
        }
    }

    $scope.limitTextLength = function(text) {
        return text.slice(0,4) + '..'
    }
    $scope.setAgentFirsAandLastName();

    $scope.agentDetails ={};
    $scope.licenseNumbersArray = [];

    var getUSStates = function() {
        UserService.getUSStates()
            .success(function(response){
                var data = response.data
                for (var y = 0; y < data.length; y++) {
                    // console.log("get data length",data.length)
                    data[y].isSelected = false
                }
                $scope.states = data;
                $scope.profileData();
            });
    };
    getUSStates();

    var setRegions = function () {
        if($scope.licenseNumbersArray.length) {
            for (var y = 0; y < $scope.states.length; y++) {
                for (var i = 0; i < $scope.licenseNumbersArray.length; i++) {
                    if ($scope.licenseNumbersArray[i].state_code == $scope.states[y].state_code && $scope.states[y].isSelected == false) {
                        $scope.states[y].isSelected = true;
                    }
                }
            }
        } 
        $scope.loadingDetailsContent = false;
    };

    $scope.profileData = function(){

        // Run only once when the tab is visited first time
        if (!$scope.profileDataInitialized) {
            $scope.tableContentLoading = true;
            $scope.profileDataInitialized = true;
        }
        // $scope.tableContentLoading = true;
        $scope.profiledata = true;
        $scope.managenumbers = false;
        $scope.targetstates = false;
        $scope.appstab = false;
        var callbacks = {
        success: function(data) {
                $scope.agentDetails = data.data; 
                // $scope.testPassword = data.data.password;
                // console.log($scope.agentDetails, "agent details")
                if($scope.agentDetails.all_us === false){
                    if ($scope.agentDetails.regions_license_dto.length > 0) {
                        // console.log("specific")
                        $scope.agentDetails.agent_region = 'specific-states';
                    }
                }
                else if($scope.agentDetails.all_us){
                    // console.log("all-us")
                    $scope.agentDetails.agent_region = 'all-us';
                }
                $scope.licenseNumbersArray = data.data.regions_license_dto;
                setRegions();
                $scope.checkZipcode()
                $scope.tableContentLoading = false;
            },
        failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        UserService.getSalesAgents($scope.user_id,callbacks); 
    } 
    $scope.profileData(); 
    
    $scope.fetchAgentTimeZones = function(){
        var callbacks = {
            success: function(data) {
                $scope.allTimeZones = data.data;
            },
            failure: function(data) {
            }
        };
        UserService.getAgentTimeZones(callbacks);
    };
    $scope.fetchAgentTimeZones(); 

    $scope.selectAllStatesFuncTwo = function (val) {
        $scope.licenseNumbersArray = [];
        for (var y = 0; y < $scope.states.length; y++) {
            $scope.states[y].isSelected = val; 

            if (val) {
                $scope.licenseNumbersArray.push({
                    state_code: $scope.states[y].state_code,
                    region_name: $scope.states[y].state_name,
                    license_number: 0
                });
            }
        }
    };
    $scope.regionSelection = function(state){
            if(state.isSelected == true){
                $scope.licenseNumbersArray.push({region_name:state.state_name,state_code:state.state_code,license_number: 0});
            }
            else if(state.isSelected == false){
                for(var i = 0; i < $scope.licenseNumbersArray.length; i++){
                    if (state.state_code == $scope.licenseNumbersArray[i].state_code){
                        $scope.licenseNumbersArray.splice(i,1);
                    } 
                }
            }
    }

    $scope.checkZipcode = function() {
        var check_zipcode = $scope.agentDetails.zip_code;
        if (check_zipcode && check_zipcode.length === 5 ) { 
            var callbacks = {
                success: function(data) {
                    if (data.data) {
                        $scope.location = data.data;
                    } 
                },
                failure: function(data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.location = {};
                }
            };
            UserService.getStateCity(check_zipcode, callbacks);
        } else {
            $scope.location = {};
        }
    };

    $scope.updateProfieData = function() {
        $scope.updateAgentDetails = {};

        if($scope.agentDetails.agent_region === 'specific-states'){
            $scope.agentDetails.allusValue = false;
            $scope.agentDetails.regions = $scope.licenseNumbersArray;
        }else if($scope.agentDetails.agent_region === 'all-us') {
            $scope.agentDetails.allusValue = true;
            $scope.agentDetails.regions = [];
        }

            if($scope.agentDetails.first_name == undefined || $scope.agentDetails.first_name == ""){
                toaster.pop('error', 'First Name', 'Please enter first name', 2000);
            }
            else if($scope.agentDetails.last_name == undefined || $scope.agentDetails.last_name == ""){
                toaster.pop('error', 'Last Name', 'Please enter last name', 2000);
            }
            else if($scope.agentDetails.phone_number == undefined || $scope.agentDetails.phone_number == ""){
                toaster.pop('error', 'phone_number', 'Please enter phone number', 2000);
            }
            else if($scope.agentDetails.zip_code == undefined || $scope.agentDetails.zip_code == ""){
                toaster.pop('error', 'zip_code', 'Please enter zip code', 2000);
            }
            // else if($scope.agentDetails.password == undefined || $scope.agentDetails.password == ""){
            //     toaster.pop('error', 'Password', 'Please enter password', 2000);
            // }
            else if($scope.agentDetails.bid_amount == undefined || $scope.agentDetails.bid_amount < 65){
                toaster.pop('error', 'Bid Amount', 'Please enter bid amount $65 or more', 2000);
            }
            // else if($scope.agentDetails.state == undefined){
            //     toaster.pop('error', 'Time Zone', 'Please select time zone', 2000);
            // }
            else if($scope.agentDetails.agent_region == undefined){
                toaster.pop('error', 'Regions', 'Please Select Region', 2000);
            }
            else if($scope.agentDetails.agent_region == undefined || ($scope.agentDetails.agent_region === 'specific-states' && $scope.agentDetails.regions == 0) ){
                toaster.pop('error', 'Regions of Operations', 'Please Select Regions of Operations', 2000);
            }
        
        else{
        $scope.tableContentLoading = true;
        $scope.updateAgentDetails.first_name = $scope.agentDetails.first_name;
        $scope.updateAgentDetails.last_name = $scope.agentDetails.last_name;
        $scope.updateAgentDetails.alias = $scope.agentDetails.first_name + '_' + $scope.agentDetails.last_name;
        $scope.updateAgentDetails.phone_number = $scope.agentDetails.phone_number;
        $scope.updateAgentDetails.zip_code = $scope.agentDetails.zip_code;
        $scope.updateAgentDetails.email = $scope.agentDetails.email;
        $scope.updateAgentDetails.bid_amount = $scope.agentDetails.bid_amount;

        // if($scope.agentDetails.password !== $scope.testPassword){
        //     // console.log("password changes ", $scope.agentDetails.password, $scope.updateAgentDetails.password)
        //     $scope.updateAgentDetails.password = $scope.agentDetails.password;
        // }

        // $scope.updateAgentDetails.state = $scope.agentDetails.state;
        $scope.updateAgentDetails.regions_license_dto = $scope.agentDetails.regions;
        $scope.updateAgentDetails.all_us = $scope.agentDetails.allusValue;

        // console.log("get salesagent update details",$scope.updateAgentDetails);

                var callbacks = {
                    success: function(data) {
                        if(data.statusCode == 200){
                            if($scope.profiledata == true){
                                toaster.pop('success', 'Success', 'Profile Successfully Updated', 2000);
                            }else {
                                toaster.pop('success', 'Success', 'States Successfully Updated', 2000);
                            }
                            $scope.tableContentLoading = false;
                            $state.go('app.sales-agent.settings');
                        } else {
                        toaster.pop('error', 'Error', 'Failed to update', 2000);
                        }
                    },
                    failure: function(data) {
                        toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                        $scope.tableContentLoading = false;
                        $state.go('app.sales-agent.settings');
                    }
                };
                UserService.updateSalesAgent(userId,$scope.updateAgentDetails,callbacks);
        }
    }

    // $scope.manageNumbers = function(){
    //     $scope.profiledata = false;
    //     $scope.managenumbers = true;
    //     $scope.targetstates = false;
    //     console.log("manage numbers tab ")
    // }

    $scope.getSettingsInfo = function(){
        console.log("get settings info")
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                console.log(data, "get setting info under apps tab")
                // $scope.locObject.integration_status;
                if(data && data.integration_status == 'connect'){
                    $scope.locObject = data;
                    $scope.appstab = true;
                    $scope.appsView = true;
                    $scope.tableContentLoading = false;
                    $scope.app.location_id = $scope.locObject.location_id;
                }
                else {
                    $scope.appstab = true;
                    $scope.appsView = false;
                    $scope.enableCancel = false;
                }
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                $scope.tableContentLoading = false;
                // $state.go('app.sales-agent.settings');
            }
        };
        UserService.getSettingsRecords(userId,callbacks);
    }

    $scope.targetStates = function() {
        $scope.profiledata = false;
        $scope.managenumbers = false;
        $scope.targetstates = true;
        $scope.appstab = false;
        // console.log("target states tab ")
    }

    $scope.appsSetting = function(){
        $scope.profiledata = false;
        $scope.managenumbers = false;
        $scope.targetstates = false;
        $scope.appstab = true;
        // $scope.tableContentLoading = true;
        $scope.getSettingsInfo()
        // console.log("Apps tab ")
    }
    

    $scope.syncApps = function(){
        $scope.tableContentLoading = true;
        // console.log($scope.app.location_id, "get location data")
        if(!$scope.app.location_id){

            toaster.pop('error', 'Location', 'Location Id required', 2000);
            return;
        }

            var callbacks = {
                success: function(response, status) {
                    console.log(response,"get post response here")

                    if(status === 200 && response.statusCode === 200){
                        successMessage = response.message;
                        // console.log(successMessage)
                        $scope.tableContentLoading = false;
                        $scope.appsView = true
                        $state.go('app.sales-agent.settings');
                        toaster.pop('success', 'Location',  successMessage , 2000);
                    }
                    else{
                        // console.log(response, "error message ")
                        errorMessage = response.message;
                        toaster.pop('error', 'Location',  errorMessage , 2000);
                    }
                    $scope.tableContentLoading = false; 
                },
                failure: function(response) {
                    // console.log(response, "from error block")
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                    $scope.tableContentLoading = false;
                    $state.go('app.sales-agent.settings');
                }
            };
            UserService.settingAppRecord(userId,$scope.app.location_id,"connect",callbacks);  
    }

    $scope.cancel = function(){
        $scope.tableContentLoading = false;
        // console.log("get cancel message ---------- $scope.locObject.location_id",$scope.locObject.location_id)
        if($scope.app.location_id !== $scope.locObject.location_id){
            $scope.app.location_id = $scope.locObject.location_id,
            $scope.appsView = true
        } else {
            $scope.appsView = true;
        }
    }

    $scope.editCRM = function(){
        console.log("edit", $scope.app.location_id)
        $scope.tableContentLoading = false;
        $scope.appstab = true;
        $scope.appsView = false;
        $scope.enableCancel = true;
        // if($scope.app.location_id){
        //     $scope.enableCancel = true;
        // }else{
        //     $scope.enableCancel = false;
        // }
    }

  }]);